import { RelayState } from '@/store/modules/relay/relayState';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/rootState';
import { RelayConnection } from '@/core/interfaces/relayConnection';
import { RelayMachine } from '@/core/interfaces/relayMachine';
import { Vehicle } from '@/core/interfaces/vehicle';

const getters: GetterTree<RelayState, RootState> = {
    connections: (state: RelayState): RelayConnection[] => state.relays.flatMap(relay => relay.connections)
        .sort((a, b) => a.name ? a.name.localeCompare(b.name || '') : 0),
    machines: (state: RelayState): RelayMachine[] => state.relays.flatMap(relay => relay.machines)
        .sort((a, b) => a.machine.localeCompare(b.machine)),
    machineByVehicle: (state: RelayState) => (vehicle: Vehicle): RelayMachine | undefined => state
        .relays.find(relay => relay.server === vehicle.relay_server_hostname)?.machines.find(m => m.machine === vehicle.name),
    connectionByUuid: (state: RelayState, getters) => (uuid: string): RelayConnection => getters.connections
        .find((connection: RelayConnection) => connection.uuid === uuid),
    servers: (state: RelayState) => state.relays.map(relay => relay.server).sort((a, b) => a.localeCompare(b)),
    activeConnections: (state: RelayState): RelayConnection[] => state.relays.find(r => r.server === state.activeServer)?.connections
        .sort((a, b) => (a.name || '')?.localeCompare(b.name || '')) || [],
    activeMachines: (state: RelayState): RelayMachine[] => state.relays.find(r => r.server === state.activeServer)?.machines
        .sort((a, b) => (a.machine || '')?.localeCompare(b.machine || '')) || [],
};

export default getters;
